<template>
	<div id="content">
		<slot />
	</div>
</template>

<script setup lang="ts"></script>

<style scoped></style>
